import script from "./customised-sop.vue?vue&type=script&lang=js&setup=true"
export * from "./customised-sop.vue?vue&type=script&lang=js&setup=true"

import "./customised-sop.vue?vue&type=style&index=0&id=d0af8146&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0af8146"]])

export default __exports__